import React, { useEffect, useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import { fetchProfileDataAPI, forgotPasswordAPI } from '../services/userApi';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import backgroundImage from '../assets/Frame_67.jpg';
import DefaultAvatar from '../assets/defaultAvatar.png';
import iconfaEllipsisVertical from '../assets/iconfaEllipsisVertical.png';
import iconfaEllipsisVerticalActive from '../assets/iconfaEllipsisVerticalActive.png';
import icon_RockSmall from '../assets/icon_RockSmall.png';
import icon_UserSmall from '../assets/icon_UserSmall.png';
import icon_mail from '../assets/icon_mail.png';
import icon_phone from '../assets/icon_phone.png';  

import Modal from 'react-modal';

const MySwal = withReactContent(Swal);

const ProfilePage= () => {
  const [profileData, setProfileData] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false); // State for modal
  const navigate = useNavigate();
  const accessToken = JSON.parse(localStorage.getItem('account'))?.access_token;
  const [user, setUser] = useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(prev => !prev); // เปิดหรือปิด Dropdown
  };

  const handleOptionClick = (action) => {
    console.log(`Action selected: ${action}`); // Debugging
    setDropdownOpen(false); // ปิด Dropdown
    if (action === "changePassword") {
      setModalOpen(true); // เปิด Modal สำหรับเปลี่ยนรหัสผ่าน
      document.body.style.overflow = 'hidden'; 
    }
  };

  const closeModal = () => {
    setModalOpen(false); // ปิด Modal
    document.body.style.overflow = 'auto'; 
  };
  //responsive
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1025);
    
  const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1025);
  }; 

  useEffect(() => {
    fetchProfile();
    fetchUserData();

    // ติดตั้ง event listener สำหรับการเปลี่ยนขนาดหน้าจอ
    window.addEventListener('resize', handleResize);

    // ฟังก์ชันคืนค่า
    return () => {
        document.body.style.overflow = 'auto'; // คืนค่าการเลื่อนเมื่อคอมโพเนนต์ถูกถอดออก
        window.removeEventListener('resize', handleResize); // ลบ event listener
    };
  }, [accessToken]);

  const onError = (title,response) => {
    MySwal.fire({
        title: title,
        html: response?.data?.error?.message,
        icon: "error",
        confirmButtonText: "Close",
        allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
          if(response?.status===401) {
              sessionStorage.removeItem('hasVisited');
              sessionStorage.removeItem('lastPath');        
              localStorage.removeItem('account');                  
              navigate('/');
          };
      }
    });
};

const onSuccess = (title, message) => {
    MySwal.fire({
        icon: 'success',
        title: title,
        text: message,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
    });
};
const fetchUserData = async () => {
  try {
      const userData = JSON.parse(localStorage.getItem('account'));
      if (userData) {
          setUser(userData);
      }
  } catch (error) {
      onError("Get Profile error",error?.response);
  }
};
  const fetchProfile = async () => {
    try {
      if (!accessToken) {
        throw new Error('Access token is missing.');
      }

      const profile = await fetchProfileDataAPI(accessToken);
      console.log('Profile Data:', profile);

      if (profile) {
        setProfileData(profile);
      } else {
        throw new Error('Invalid response data from server.');
      }
    } catch (error) {
       // ลบข้อมูลจาก sessionStorage และ localStorage
       sessionStorage.removeItem('hasVisited');
       sessionStorage.removeItem('lastPath');
       localStorage.removeItem('account');
       
       // แสดง error ถ้ามี
       onError("Get Profile error", error?.response);
 
       // นำทางไปยังหน้าใหม่
       navigate('/');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('account'); // ลบข้อมูลบัญชีผู้ใช้จาก localStorage
    navigate('/'); // นำผู้ใช้ไปยังหน้าเข้าสู่ระบบ
  };

  
  const handleForgotPassword = async () => {
    try {
      const email = JSON.parse(localStorage.getItem('account'))?.email;
  
      if (!email) {
        onError('เกิดข้อผิดพลาด!', { data: { error: { message: 'ไม่พบอีเมลใน local storage.' } } });
        return;
      }
  
      const response = await forgotPasswordAPI(email);
      console.log('API Response:', response);
  
      if (response.status === true) {
        onSuccess('สำเร็จ!', 'ลิงก์รีเซ็ตรหัสผ่านถูกส่งไปยังอีเมลของคุณ.'); // เรียกใช้ฟังก์ชัน onSuccess
        navigate('/');
      } else {
        throw new Error('Failed to reset password.'); // เงื่อนไขนี้จะไม่เกิดขึ้นหาก response.status เป็น true
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      onError('เกิดข้อผิดพลาด!', { data: { error: { message: 'ไม่พบอีเมลใน local storage.' } } });
    } finally {
      setModalOpen(false); // ปิด modal เสมอ
    }
  };

  const handleEditProfile = () => {
    // ส่งข้อมูลผู้ใช้ไปยังหน้า editprofile
    navigate('/editprofile', { state: { profileData } });
  };
  

  return (
    <main style={{ paddingTop: '90px' }}>
      <div style={styles.background}></div>
      <div style={styles.container}>
        <h1 style={{textAlign:'left'}}>โปรไฟล์</h1>
        {profileData ? (
          <div>
            <div style={styles.Sectionone}>
              <div style={styles.Sectiontwo}>
                <div style={styles.ImgArea}>
                  <img 
                    src={profileData.image_url ? profileData.image_url : DefaultAvatar} 
                    alt="Profile" 
                    style={styles.ImgProfile}
                  />
                </div>
                <div>
                  <p style={{fontSize:'0.8vw',color:'#44526e',margin:'8px 0'}}>{profileData.rank_position}</p>
                  <div style={{display:'flex',gap:'8px'}}>
                    <p style={{fontSize:'1vw',color:'Black',fontWeight:"bold",margin:'8px 0'}}>{profileData.short_position}</p>
                    <p style={{fontSize:'1vw',color:'Black',fontWeight:"bold",margin:'8px 0'}}>{profileData.first_name}</p>
                    <p style={{fontSize:'1vw',color:'Black',fontWeight:"bold",margin:'8px 0'}}>{profileData.last_name} </p>
                    <p style={{fontSize:'1vw',color:'Black',margin:'8px 0'}}>({profileData.nick_name})</p>
                  </div>
                  <p style={{fontSize:'0.8vw',color:'#44526e',margin:'8px 0'}}>{profileData.full_position}</p>
                  <div style={styles.textIcon}>
                    <img src={icon_mail} alt="icon_mail" style={styles.imgIcon}/>
                    <p style={{fontSize:'0.8vw',color:'#595959',margin:'8px 0'}}>{profileData.email}</p>
                  </div>
                  <div style={styles.textIcon}>
                    <img src={icon_phone} alt="icon_phone" style={styles.imgIcon}/>
                    <p style={{fontSize:'0.8vw',color:'#595959',margin:'8px 0'}}>{profileData.phone}</p>
                  </div>
                </div>
              </div>
              <div style={{ position: 'relative' }}>
                {/* ปุ่มที่มี Icon */}
                <button 
                  onClick={toggleDropdown} 
                  style={styles.DropdownBTN}
                >
                  <img   src={isDropdownOpen ? iconfaEllipsisVerticalActive : iconfaEllipsisVertical} 
                  alt="iconfaEllipsisVertical" style={styles.imgIconDropdown}/>
                </button>
                {/* ตัวเลือก dropdown */}
                {isDropdownOpen && (
                  <div style={styles.dropdown}>
                    <div style={styles.containerDropdown} onClick={() => setModalOpen(true)}>
                      <img src={icon_RockSmall} alt="icon_RockSmall" />
                      <p  onClick={() => handleOptionClick("changePassword")}><a style={styles.textDropdown}>แก้ไขรหัสผ่าน</a></p>
                    </div>
                    <hr style={{margin:0}} />
                    <div style={styles.containerDropdown}>
                      <img src={icon_UserSmall} alt="icon_UserSmall" style={{width:'15px',height:'auto',margin:'5px'}} />
                      <p><Link to="/editprofile" style={styles.textDropdown}>แก้ไขโปรไฟล์</Link></p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div style={styles.containerInfo}>
              <p style={styles.labelText}>ข้อมูลส่วนตัว และการทำงาน</p>
              <div style={styles.contentFlex}>
                 <div style={styles.contentDetail}>
                  <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>วัน เดือน ปีเกิด</p>
                  <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.birthday}</p>
                 </div>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>ศาสนา</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.religion}</p>
                 </div>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>สถานภาพ</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.marital_status}</p>
                 </div>
              </div>
              <div style={styles.contentFlex}>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>สังกัด</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.department}</p>
                 </div>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>เหล่าทหาร</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.military_branch}</p>
                 </div>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>จำพวกทหาร</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.military_type}</p>
                 </div>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>ภูมิลำเนา</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.hometown}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>หน้าที่ความรับผิดชอบโดยสังเขป</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.responsibility}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>หลักสูตรต่าง ๆ ที่เคยศึกษาขณะรับราชการ</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.training_course}</p>
              </div>
            </div>
            <div style={styles.containerInfo}>
              <p style={styles.labelText}>ที่พักและการเดินทาง</p>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>บริเวณที่พำนักขณะเข้ารับการศึกษา (ตำบล/แขวง)</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.residence_during_study}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>วิธีการเดินทางมาศึกษา</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.transportation_method}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>ทะเบียนรถที่ใช้เดินทางมาศึกษา</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.vehicle_registration_number}</p>
              </div>
            </div>
            <div style={styles.containerInfo}>
              <p style={styles.labelText}>ข้อมูลด้านสุขภาพ</p>
              <div style={styles.contentFlex}>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>หมู่โลหิต</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0' ,fontWeight:'bold'}}>{profileData.blood_group}</p>
                 </div>
                 <div style={styles.contentDetail}>
                   <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>โรคประจำตัว</p>
                   <p style={{ fontSize: '1vw', color: 'black', margin: '0' ,fontWeight:'bold'}}>{profileData.chronic_illness}</p>
                 </div>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>อาหารที่แพ้/สิ่งที่แพ้</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0' ,fontWeight:'bold'}}>{profileData.allergy}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>ยาที่แพ้</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0' ,fontWeight:'bold'}}>{profileData.drug_allergy}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>ข้อจำกัดด้านร่างกายที่ผู้ควบคุมหลักสูตรจำเป็นต้องรับทราบ</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.physical_limitation}</p>
              </div>
            </div>
            <div style={styles.containerInfo}>
              <p style={styles.labelText}>ข้อมูลการศึกษาและงานอดิเรก</p>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>การศึกษาสูงสุด (ระบุวุฒิ สาขา และสถานศึกษาที่จบ)</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0',fontWeight:'bold' }}>{profileData.highest_education_level}</p>
              </div>
              <div style={styles.contentDetail}>
                <p style={{ fontSize: '0.9vw', color: '#44526e', margin: '0' }}>งานอดิเรก (สิ่งที่ทำในยามว่างและมีประโยชน์)</p>
                <p style={{ fontSize: '1vw', color: 'black', margin: '0' ,fontWeight:'bold'}}>{profileData.hobby}</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              style={styles.logoutBtn}
            >
              ออกจากระบบ
            </button>
          </div>
        ) : (
          <p>กำลังโหลดข้อมูล...</p> // Show a loading message if profileData is not available
        )}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 2,
       },
       content: {
           top: '50%',
           left: '50%',
           right: 'auto',
           bottom: 'auto',
           marginRight: '-50%',
           transform: 'translate(-50%, -50%)',
           width: '100%',
           maxWidth:'764px',
           padding: '24px 54px 24px 54px',
           borderRadius: '36px',
           boxSizing:'border-box',
           backgroundSize: 'cover',
           backgroundPosition: 'center',
       }
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
          <p style={{fontSize:'1.5vw'}}>คุณต้องการแก้ไขรหัสผ่านใช่หรือไม่?</p>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',width:'100%' }}>
            <button onClick={closeModal} style={styles.btnCancel}>
              ยกเลิก
            </button>
            <button onClick={handleForgotPassword} style={styles.btnConfirm}>
              ยืนยัน
            </button>
          </div>
        </div>

      </Modal>
    </main>
  );
};

const styles = {
  background: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.25)), url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: '-1',
  },
  container: {
    boxSizing: 'border-box',
    background:' white',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '80%',
    borderRadius: '36px',
    margin: '25px auto', // จัดให้อยู่ตรงกลางในแนวนอน
    padding: '24px',
    gap:'24px' ,
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  },
  Sectionone:{
    display:'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid #dddddd', // เส้นขอบด้านบน
    borderBottom: '1px solid #dddddd', // เส้นขอบด้านล่าง
    padding: '24px 0',
  },
  Sectiontwo:{
    display:'flex',
    textAlign:'left',
    alignItems: 'center',
    gap:'42px' ,
  },
  ImgProfile:{
     width: '100%',
      height: '100%',
      objectFit: 'cover'
  },
  ImgArea:{
    width: '200px', 
  height: '200px', 
  borderRadius: '50%', 
  overflow: 'hidden', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center'
  },
  dropdown: {
    position: 'absolute',
    top: '25%', // ทำให้ dropdown อยู่ด้านล่างของปุ่ม
    right: '35%',
    backgroundColor: '#fff',
    border: '1px solid #dddddd',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    zIndex: '1000',
    borderRadius:'16px',
    width:'100%',
    boxSizing:'border-box',
    minWidth: '200px',
    alignItems:'center'
  },
  textDropdown:{
    textDecoration:'none',
    color:'#44526e',
    fontWeight:'bold',
    fontSize:'0.9vw',
    textAlign:'center',
    whiteSpace: 'nowrap',
    cursor:'pointer'
  },
  DropdownBTN:{
    background: 'none', 
    border: 'none', 
    cursor: 'pointer', 
    position: 'relative',
    width:'100%',
  },
  imgIconDropdown:{
    width:'30%'
  },
  imgIcon:{
    width:'10%'
  },
  containerDropdown:{
    padding:'0 24px',
    display:'flex',
    alignItems:'center',
    boxSizing:'border-box',
    gap:'24px'
  },
  textIcon:{
    display:'flex',
    alignItems:'center',
    gap:'8px'
  },
  containerInfo:{
    border:'1px solid #dddddd',
    background:'#f5f5f5',
    padding:'24px',
    marginTop:'24px',
    borderRadius:'16px',
    textAlign:'left'
  },
  labelText:{
    fontWeight:'bold',
    fontSize:'1vw'
  },
  contentDetail: {
    background: 'white',
    padding: '8px 16px',
    borderRadius: '16px',
    border: '1px solid #dddddd',
    width: '100%',
    marginBottom: '24px',
    boxSizing: 'border-box',
    textAlign: 'left', // ข้อความชิดซ้าย
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start', // จัดให้เนื้อหาชิดซ้ายภายในช่อง
    justifyContent: 'center',
    gap:'8px'
},

  contentFlex:{
    display:'flex',
    gap:'24px',
    width:'100%'
  },
  logoutBtn:{
    padding: '10px',
    backgroundColor: 'white',
    color: 'red',
    border: '2px solid red',
    borderRadius: '64px',
    cursor: 'pointer',
    fontSize: '24px',
    width:'100%',
    marginTop:'42px'
  },
  btnConfirm:{
    padding: '10px',
    backgroundColor: '#44526e',
    color: '#fff',
    border: 'none',
    borderRadius: '64px',
    cursor: 'pointer',
    marginRight: '10px',
    width:'100%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    fontWeight:'bold',
    fontSize:'1vw'
  },
  btnCancel:{
    padding: '10px',
    backgroundColor: 'white',
    color: '#44526e',
    border: '1px solid #44526e',
    borderRadius: '64px',
    cursor: 'pointer',
    marginRight: '10px',
    width:'100%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    fontWeight:'bold',
    fontSize:'1vw'
  },
};


export default ProfilePage;
